module.exports = __webpack_public_path__ + "7802e1a6a765f6f89edd168b59bad3ac.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Game/jotto_game.png
 ** module id = 335
 ** module chunks = 0
 **/